import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  COUPON: {
    LIST_ALL: {
      REFRESH: 'COUPON.LIST_ALL.REFRESH',
      REFRESHING: 'COUPON.LIST_ALL.REFRESHING',
      REFRESHED: 'COUPON.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'COUPON.LIST_ALL.REFRESH_ERROR'
    },
    CREATE_OR_UPDATE: {
      SHOW: 'COUPON.CREATE_OR_UPDATE.SHOW'
    },
    SUBMIT: 'COUPON.SUBMIT',
    DELETE: 'COUPON.DELETE',
    UPDATE: 'coupon.update',
    UPDATED: 'coupon.updated',
    UPDATE_SETTINGS: 'COUPON.UPDATE_SETTINGS'
  }
};

export const ENDPOINTS = {
  COUPON: {
    GET_LIST:
      '/store/app/data?service=kingrecharges&userId=kingrecharges-coupons&group=lacasae',
    UPDATE:
      '/store/app/data?service=kingrecharges&userId=kingrecharges-coupons&group=lacasae'
  }
};

export const COUPON = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  }
};
